import React, { useState, useEffect } from 'react';
import classNames from 'classnames';

import closeIcon from '../../../assets/images/x_icon_black.svg';
import editIcon from '../../../assets/images/edit.svg';
import saveIcon from '../../../assets/images/check-mark-black.svg';

import './index.scss';

const ProfileInfo = ({
  details,
  selectedConversation,
  editCallerName,
}) => {
  const [name, setCallerName] = useState(details.name);
  const [nameError, serError] = useState(false);
  const [namefieldReadonly, setnamefieldReadonly] = useState(true);
  useEffect(() => {
    setCallerName(details.name);
  }, [details.name]);

  const onCallerNameChange = (event) => {
    let inputValue = event?.target?.value || '';
    let sanitizedValue = inputValue.replace(/[^a-zA-Z0-9 ]/g, '').trimStart();
    if (sanitizedValue === '' && inputValue !== '') {
      return;
    }
    serError(sanitizedValue.length === 0);
    setCallerName(sanitizedValue);
  };

  const editName = (name) => {
    console.log(name);
    setnamefieldReadonly(false);
  };

  const saveName = () => {
    if (name.length > 1) {
      setnamefieldReadonly(true);
      editCallerName(name, details.bzId, details.id, selectedConversation.userId);
    } else {
      serError(true);
    }
  };

  return (
    <div className="client-profile__card">
      <h1 className="client-profile__card__heading">Profile info</h1>
      <div className="client-profile__card__content">
        <ul>
          <li>
            <div className="name-editable">
              <span className="client-profile__card__content__list-head">
                Name:
              </span>
              <input
                className={classNames(
                  'client-profile__card__content__list-textinput',
                  { 'read-write': !namefieldReadonly },
                )}
                type="text"
                value={name}
                onChange={onCallerNameChange}
                disabled={namefieldReadonly}
              />
              <div className="icon-list">
                {namefieldReadonly ? (
                  <img
                    className="edit-icon"
                    src={editIcon}
                    onClick={() => editName(name)}
                  />
                ) : (
                  <>
                    <img
                      className="save-icon"
                      onClick={() => saveName()}
                      src={saveIcon}
                    />{' '}
                    <img
                      className="close-icon"
                      onClick={() => setCallerName('')}
                      src={closeIcon}
                    />
                  </>
                )}
              </div>
            </div>
            {nameError && <div className="error-message">Please enter valid name</div>}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ProfileInfo;
